<template>
  <div>
    <tr class="m-t-10 card-print">
      <td :rowspan="observations.length == 0 ?1:observations.length" class="text-left">
        {{ indicator.control_point_name }}
      </td>
      <td :rowspan="observations.length == 0 ?1:observations.length" class="text-left">
        <span v-if="indicator.obligation === 'MAJOR_MUST'">Major Must</span>
        <span v-if="indicator.obligation === 'MINOR_MUST'">Minor Must</span>
      </td>
      <td :rowspan="observations.length == 0 ?1:observations.length">
        {{ indicator["description"] }}
      </td>
      <td>
        <template v-if="observations.length > 0">
          <span v-if="observations[0].compliance === 'Compliant'" class="text-dark-green">Compliant</span>
          <span v-if="observations[0].compliance === 'NonCompliant'" class="label label-danger">Non-Compliant</span>
          <span v-if="observations[0].compliance === 'NotApplicable'" class="label label-secondary">Not Applicable</span>
        </template>
      </td>
      <td>
        <template v-if="observations.length > 0">
          <span v-html="observations[0].procedural_note" />
        </template>
      </td>
      <td>
        <template v-if="observations.length > 0">
          <span v-html="observations[0].created_at" />
        </template>
      </td>
    </tr>
    <template v-for="(observation, i) in observations">
      <tr v-if="i > 0">
        <td>
          <span v-if="observation.compliance === 'Compliant'" class="text-dark-green">Compliant</span>
          <span v-if="observation.compliance === 'NonCompliant'" class="label label-danger">Non-Compliant</span>
          <span v-if="observation.compliance === 'NotApplicable'" class="label label-secondary">Not Applicable</span>
        </td>
        <td>
          <span v-html="observation.procedural_note" />
        </td>
        <td>{{ observation.created_at }}</td>
      </tr>
    </template>
  </div>
</template>

<script>

export default {
  name: 'Indicator',
  props: ['auditId', 'status', 'indicator', 'id', 'impactArea', 'events'],
  data() {
    return {
      observations: []
    };
  },
  mounted() {
    this.getObservations();
  },
  methods: {
    getPityName(name) {
      return name.substring(name.indexOf(' '));
    },
    async getObservations() {
      try {
        this.observations = (await this.$api.get(`audits/${this.auditId}/control_points/${this.id}/observations`)).data;
      } catch (e) {
        console.error(e);
      }
    }
  }
}
</script>

<style scoped>
.table th {
  text-align: center !important;
}
</style>
